import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ApolloProvider } from '@apollo/client';
import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import Luxon from '@date-io/luxon';
import { DateTimeServiceProvider } from './utils/hooks/dateTimeService';
import { PriceServiceProvider } from './utils/hooks/priceService';
import { ProvideAuth } from './utils/hooks/auth';
import client from './graphql/client';
import theme from './theme';
import { ProvideVenueShiftContext } from './utils/hooks/useVenueSwitchContext';

const GlobalStyle = createGlobalStyle`
  .react-grid-placeholder {
      border: 1px dashed #000000;
  }
  body {
    touch-action: manipulation;
  }
  .Toastify {
        position: absolute;
        z-index: 999999;
    }

    .MuiTableBody-root > .MuiTableRow-root {
        background: ${props => props.theme.palette.background.default};
    }

    .MuiTableBody-root > .MuiTableRow-root:nth-child(2n) {
        background: #FFFFFF;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
`;

const Providers: React.FC = ({ children }) => {
    return (
        <ApolloProvider client={client}>
            <MuiPickersUtilsProvider utils={Luxon}>
                <MuiThemeProvider theme={theme}>
                    <ThemeProvider theme={theme}>
                        <GlobalStyle />
                        <CssBaseline />
                        <ToastContainer />
                        <ProvideAuth>
                            <ProvideVenueShiftContext>
                                <PriceServiceProvider>
                                    <DateTimeServiceProvider>
                                        <DndProvider backend={HTML5Backend}>
                                            {children}
                                        </DndProvider>
                                    </DateTimeServiceProvider>
                                </PriceServiceProvider>
                            </ProvideVenueShiftContext>
                        </ProvideAuth>
                    </ThemeProvider>
                </MuiThemeProvider>
            </MuiPickersUtilsProvider>
        </ApolloProvider>
    );
};

export default Providers;
